import { ActivityInstance, ActivityInstanceStatus, UpdateActivityInstanceStateAddendum } from '@things-factory/worklist'

import { DataOoc, DataOocStatus } from '../service/data-ooc/data-ooc.js'
import { DataSample } from '../service/data-sample/data-sample.js'
import { createDataOoc } from '../controllers/create-data-ooc.js'
import { issueOocResolve } from '../controllers/issue-ooc-resolve.js'

async function callback(
  activityInstance: ActivityInstance,
  addendum: UpdateActivityInstanceStateAddendum,
  context: ResolverContext
) {
  const { domain, tx } = context.state
  const { input, output, state } = activityInstance

  if (state == ActivityInstanceStatus.Ended) {
    const { dataSampleId } = input || {}

    if (!dataSampleId) {
      throw new Error('Data sample ID is missing in the input.')
    }

    const dataSample = await tx.getRepository(DataSample).findOne({
      where: { domain: { id: domain.id }, id: dataSampleId },
      relations: ['domain', 'dataSet', 'creator', 'updater']
    })

    await tx.getRepository(DataSample).save({
      ...dataSample,
      output,
      state: DataOocStatus.REVIEWED
    })

    const { judgment, instruction } = output

    if (judgment == 'abnormal') {
      /* Review 결과가 Ooc 조치가 필요하다고 하면, DataOoc를 생성하고, DataOocResolve를 이슈한다. */
      const dataSet = dataSample.dataSet
      var ooc = await createDataOoc(dataSample, dataSet, context)

      ooc = await tx.getRepository(DataOoc).save({
        ...ooc,
        reviewedAt: activityInstance.terminatedAt,
        reviewer: activityInstance.updater,
        correctiveInstruction: instruction,
        reviewActivityInstance: activityInstance,
        state: DataOocStatus.REVIEWED
      })

      // save() 후 dataSet relation이 손실되므로 다시 설정
      ooc.dataSet = dataSet

      await issueOocResolve(ooc, dataSet, instruction, context)
    }
  }
}

export const ActivityDataReview = {
  name: 'Data Review',
  description: 'Tasks for data review',
  release: '1.0.0',
  provider: 'hatiolab.com',
  category: 'quality',
  activityType: 'user',
  priority: 1,
  searchKeys: [
    {
      name: 'dataSetName',
      description: 'DataSet name',
      inputKey: 'dataSetName',
      tKey: 'data-set-name'
    }
  ],
  startingType: '',
  multiple: 'single',
  model: [
    {
      name: 'dataSetId',
      description: 'DataSet Id.',
      tag: 'dataSetId',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    },
    {
      name: 'dataSetName',
      description: 'DataSet name',
      tag: 'dataSetName',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    }
  ],
  uiType: 'custom-element',
  uiSource: 'activity-data-review-edit',
  viewType: 'custom-element',
  viewSource: 'activity-data-review-view',
  reportType: 'custom-element',
  reportSource: 'activity-data-review-view',
  thumbnail: '/assets/images/data-collect.png',
  standardTime: 24 * 60 * 60, // seconds
  callback /* Called when there is a change in the lifecycle of a task (activity-instance). */
}
